export default "__VITE_ASSET__DcfQAmls__"